function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 15C18 10.5817 14.4183 7 10 7C5.58172 7 2 10.5817 2 15",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 5H8.5",
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15H19V18H1V15Z",
  stroke: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10 7V5",
  stroke: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2C17 2 20 5 20 8M14 4.5C16 4.5 17.5 6 17.5 8",
  stroke: "black"
});

var SvgRingBell1 = function SvgRingBell1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRingBell1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ring-bell-1.cd66097a.svg";
export { ForwardRef as ReactComponent };